module.exports = __webpack_public_path__ + "img/ic_shopping_cart_blue.9fbc11b8.svg";